import notify from '@/api/notification'
import payments from '@/api/payments'

const state = {
  paymentsList: [],
  isLoadingPayments: false,
  entityResume: null
}

const mutations = {
  updatePaymentsList(state, data) {
    state.paymentsList = data
  },
  setPaymentsLoadingStatus(state, status) {
    state.isLoadingPayments = status
  },
  updateEntityResume(state, entityResume) {
    state.entityResume = entityResume
  }
}

const getters = {
  paymentsList(state) {
    return state.paymentsList
  },
  isLoadingPayments(state) {
    return state.isLoadingPayments
  },
  paymentsByStatus(state) {
    return state.paymentsList.reduce(function(acc, payment) {
      acc[payment.status] = (acc[payment.status] || 0) + 1
      return acc
    }, {})
  }
}

const actions = {
  getPaymentHistory({ commit }, date) {
    commit('setPaymentsLoadingStatus', true)
    return payments
      .getPaymentHistory(date)
      .then(function(res) {
        commit('updatePaymentsList', res.data)
        commit('setPaymentsLoadingStatus', false)
      })
      .catch(function(err) {
        commit('setPaymentsLoadingStatus', false)
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar lista de faturas.'
        })
        console.error('err -->', err)
      })
  },
  cleanPaymentList({ commit }) {
    commit('updatePaymentsList', [])
  },
  getEntityResume({ commit }, walletType) {
    return payments
      .getEntityResume(walletType)
      .then(function(res) {
        commit('updateEntityResume', res.data)
      })
      .catch(function(err) {
        notify({
          title: 'ERRO: ',
          message: 'Não foi possível atualizar os dados financeiros.'
        })
        console.error('err -->', err)
      })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}

export { mutations, actions, getters }
